import Vue from 'vue';
import VueLocalforage from 'v-localforage';
Vue.use(VueLocalforage);
export default {
  vuexComputed,
  vuexSimple,
  vuexComputedNamespace,
  loadForage,
  licensePlate,
  prettyDate,
  setDefaults,
  moveOrAdd,
  noop,
  range,
  lpFromUrl
};
export function vuexSimple(options, props) {
  const { state = {}, mutations = {}, actions = {}, getters = {} } = options;
  options.state = state;
  options.mutations = mutations;
  options.actions = actions;
  options.getters = getters;
  Object.entries(props).forEach(([prop, initial]) => {
    state[prop] = state[prop] || initial;
    mutations[prop] = mutations[prop] || ((state, value) => (state[prop] = value));
    actions[prop] = actions[prop] || (({ commit }, value) => commit(prop, value));
    getters[prop] = getters[prop] || (state => state[prop]);
  });
  return options;
}
export function vuexComputed(...props) {
  return props.reduce((map, prop) => {
    return {
      ...map,
      [prop.replace(/^[^\/]\//, '')]: {
        get() {
          return this.$store.getters[prop];
        },
        set(value) {
          this.$store.dispatch(prop, value);
        }
      }
    };
  }, {});
}
export function vuexComputedNamespace(...props) {
  return props.reduce((map, prop) => {
    return {
      ...map,
      [prop]: {
        get() {
          return this.$store.getters[key(this)];
        },
        set(value) {
          this.$store.dispatch(key(this), value);
        }
      }
    };
    function key({ namespace }) {
      const ns = (namespace && namespace + '/') || '';
      return ns + prop;
    }
  }, {});
}
export async function loadForage(props, NS = '') {
  const lf = Vue.$localforage;
  const keys = await lf.keys();
  console.log('lf keys', NS, keys);
  await Promise.all(
    keys.map(async nsKey => {
      const key = (nsKey && nsKey.replace(new RegExp('^' + NS), '')) || key;
      // console.log('1) have nsKey?', key, nsKey, key in props, nsKey in props);
      if (key in props && NS + key === nsKey) {
        // console.log('2) setting key in props', key);
        // props[key] = await lf.getItem(nsKey);
        const value = (props[key] = await lf.getItem(nsKey));
        // console.log('3) set key value', key, value);
      }
    })
  );
}
export function licensePlate() {
  return [alpha(), alpha(), alpha(), '-', numeric(), numeric(), numeric()].join('');
  //return 'test-' + (new Date() * 1);
  function alpha() {
    return String.fromCharCode(numeric(90, 65));
  }
  function numeric(max = 9, min = 0) {
    const delta = max + 1 - min;
    return Math.floor(Math.random() * delta + min);
  }
}
export function prettyDate(date) {
  const months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const [all, year, month, day] = /(\d{4})-(\d{2})-(\d{2})T/.exec(date);
  return `${ months[num(month)] } ${ num(day) }, ${ year }`;
  function num(text) {
    return text.replace(/^0/, '') * 1;
  }
}
export function setDefaults(props) {
  Object.entries(props).forEach(([key, value]) => {
    const raw = key.replace(/^default_/, '');
    if (key !== raw && !value) {
      // set defaults
      props[key] = props[raw];
      //console.log('setting defaults', key, value, props[raw]);
    }
  });
}
export function moveOrAdd(array, to, item) {
  let r = false;
  if (to > -1) {
    const from = array.indexOf(item);
    const noop = to === from;
    const adjust = from < to && -1 || 0;
    let found;
    if (noop) {
      console.log('to matches from');
    } else {
      if (from === -1) {
        //console.log('external window', id);
        array.splice(to, 0, item);
      } else {
        //console.log('drop had', to, from, adjust, to * 1 + adjust);
        found = array.splice(from, 1)[0];
        array.splice(to * 1 + adjust, 0, found);
      }
      //this.playlist = this.playlist.splice()
      r = true;
      // todo: save to server with token
      console.log('success');
      //console.log('success', array, found);
    }
  } else {
    console.log('no drop before');
  }
  //console.log('moveOrAdd', r);
  return r;
}
export function noop() {}
export function range(start, stop, step = 1) {
  return Array.from({ length: (stop - start) / step }, (_, i) => start + i * step);
}
export function lpFromUrl(url, reg = /[A-Z]{3}\-?[0-9]{3}/i) {
  //console.log('lpFromUrl', url);
  const lp = (reg.exec(url) || [])[0];
  return lp && normalizeLp(lp);
}
function normalizeLp(lp = '') {
  return lp.replace(/([A-Z]{3})\-?/i, '$1-').toUpperCase();
}